module.exports = __webpack_public_path__ + "img/ic_box.6c8ee464.svg";